/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

import '~styles/modules/sectionHeader.scss';

const SectionHeader = ({ data }) => {
  const anchor = data.section

  //const image = "style='background-image: url("+photo+"')"

  if(anchor=="top"){
  	return (
  		<div className="top-header" id={anchor}></div>
  	);
  }else{
  	return (
  		<div className="section-headers" id={anchor}></div>
  	  	
  	);
  }

  

};




export default SectionHeader;
